<div class="account-card">
  @for (row of rows; track row.id) {
  <button type="button" class="account-row" [class.danger]="row.danger" (click)="rowSelected.emit(row)">
    <ion-icon class="row-icon" [name]="row.icon" aria-hidden="true" />
    <span class="row-title">{{ row.labelKey | translate }}</span>
    @if (!row.danger) {
    <ion-icon class="row-chevron" name="chevron-forward-outline" aria-hidden="true" />
    }
  </button>
  }
</div>
